// ======================================================================
// File Name       : UserRegistUpdateContainner.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { Col, Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import UserRegisterUpdate from '../../components/user/UserRegisterUpdate';
import { MODE, SELECT_TARGET_DATA, PASS_STRENGTH_TYPE, DORMANT_STATE } from '../../constants/index';
import { USER_TYPE } from '../../constants/UserConstants';
import {
  searchUser,
  getGroupList,
  getAuthorityList,
  getChildUserList,
  registerUpdateUser,
  getAttributeListForUser,
  editChildUserList,
  getUserList,
  removedDataUserHasGroupAndRole,
  getUserGroupRelation,
  getGroupListAll,
} from '../../actions/UserAction';
import { USER_LIST } from '../../constants/PathConstants';
import SelectGroupDlg from '../../components/group/SelectUserGroupDialog';
import ChildUserContainer from './ChildUserContainer';
import UserCheckContainer from './UserCheckContainer';
import { serviceSearchWithoutGetEnterprise } from '../../actions/ServiceAction';
import { SERVICE_TYPE } from '../../constants/ServiceConstant';
import Header from '../../components/Header';
import { isSuperUser } from '../../utils/index';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';
import * as ImportUtils from '../../utils/ImportUtils';

class UserRegisterUpdateContainer extends Component {
  constructor() {
    super();
    this.state = {
      mode: 0,
      showSelectGroup: false,
      showRelationMode: false,
      showCheck: false,
      userDetail: {
        userType: USER_TYPE.STUDENT,
        dormantState: DORMANT_STATE.ACTIVE,
        password: '',
        userName: '',
        loginId: '',
        managementAuthoritySecernId: '',
        mailAddress: '',
        dormantStateChangeDate: '',
        dormantStateChangeFlag: 0,
        loginIdPasswordSendFlag: 0,
      },
      oldSelectedGroupList: [],
      selectedGroupList: [{ groupSecernId: '' }],
      groupList: [],
      childUserList: [],
      managementAuthorityList: [],
      userAttributes: {
        byKeyNum: {},
        allKeyNums: [],
      },
      isClosed: true,
      buttonText: 'plus',
      indexGroup: null,
      passwordStrength: PASS_STRENGTH_TYPE.STRONG,
      isGetChildList: false,
      isGetServiceInfo: false,
      isLocked: false,
      serviceType: null,
      isUserHasGroup: false,
    };
    this.openOrCloseAttributeArea = this.openOrCloseAttributeArea.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.onHandleChangeAttribute = this.onHandleChangeAttribute.bind(this);
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.addGroup = this.addGroup.bind(this);
    this.deleteGroup = this.deleteGroup.bind(this);
    this.deleteChildUser = this.deleteChildUser.bind(this);
    this.showUserRelation = this.showUserRelation.bind(this);
    this.onUserRelationCancel = this.onUserRelationCancel.bind(this);
    this.onUserRelationOk = this.onUserRelationOk.bind(this);
    this.showCheckDlg = this.showCheckDlg.bind(this);
    this.okCheckDlg = this.okCheckDlg.bind(this);
    this.cancelCheckDlg = this.cancelCheckDlg.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
  }

  componentWillMount() {
    const { dispatch, authedUser, match } = this.props;
    const mode = match.params.id ? MODE.EDIT_MODE : MODE.NEW_MODE;
    const userInfoAuthed = authedUser.userInfo;
    const { displayUserType } = userInfoAuthed;
    // Step 11.2.0 START
    const userSecernId = authedUser.userInfo.representationUserSecernId
      ? authedUser.userInfo.representationUserSecernId
      : authedUser.userInfo.userSecernId;
    // Step 11.2.0 END
    const checkSuperUser = isSuperUser(displayUserType);
    let isUserHasGroup = false;
    // Step 11.2.0 START
    if (!checkSuperUser || (checkSuperUser && authedUser.userInfo.representationUserSecernId)) {
    // Step 11.2.0 END
      dispatch(getUserList(userSecernId));
      dispatch(getUserGroupRelation(userSecernId, true)).then((result) => {
        if (result.data && result.data.recordNum) {
          dispatch(getGroupListAll());
          isUserHasGroup = true;
        }
        this.setState({ isUserHasGroup }, () => {
          this.getDataForUserDetail(this.props, false, isUserHasGroup);
        });
      });
    } else {
      this.getDataForUserDetail(this.props, false);
    }
    this.getServiceForUser();
  }

  componentWillUnmount() {
    this.props.dispatch(removedDataUserHasGroupAndRole());
  }

  componentWillReceiveProps(nextProps) {
    this.getDataForUserDetail(nextProps, true);
  }

  getDataForUserDetail(props, isReceiveProps, isUserHasGroup) {
    const { user, match, dispatch, authedUser, service } = props;
    const mode = match.params.id ? MODE.EDIT_MODE : MODE.NEW_MODE;
    const { userInfo, managementAuthorityList, groupList, userAttributes } = user;
    if (managementAuthorityList && managementAuthorityList.length) {
      const place = managementAuthorityList.findIndex(o => o.managementAuthoritySecernId === null);
      if (place !== -1) {
        managementAuthorityList.splice(place, 1);
      }
    }
    if (mode === MODE.EDIT_MODE) {
      // Get data for edit user
      const { childUserList } = user;
      const userDetail = userInfo.bySecernId[match.params.id];
      if (!userDetail) {
        const userSecernIdList = [match.params.id];
        if (!isReceiveProps) {
          dispatch(searchUser(undefined, userSecernIdList, isUserHasGroup));
          dispatch(getAttributeListForUser(match.params.id));
        }
      } else {
        if (
          userDetail.userType === USER_TYPE.GUARDIAN &&
          childUserList.length === 0 &&
          !this.state.isGetChildList
        ) {
          dispatch(getChildUserList(userDetail.userSecernId));
          const isGetChildList = true;
          this.setState({ isGetChildList });
        }
        let selectedGroupList = [{ groupSecernId: '' }];
        let oldSelectedGroupList = [];
        if (userDetail.groupRelationList && userDetail.groupRelationList.length !== 0) {
          const groupRelationList = [...userDetail.groupRelationList];
          selectedGroupList = $.extend(true, [], userDetail.groupRelationList);
          oldSelectedGroupList = $.extend(true, [], userDetail.groupRelationList);
        }
        userDetail.password = userDetail.password ? userDetail.password : '';
        // Check user is locked to handle for check/uncheck ロック状態
        let isLocked = this.state.isLocked;
        if (userDetail.lockState === 1) {
          isLocked = true;
        }
        this.setState({
          userDetail,
          mode,
          managementAuthorityList,
          groupList,
          selectedGroupList,
          oldSelectedGroupList,
          childUserList,
          isLocked,
        });
      }
    } else {
      // Get data for new user
      const { userDetail } = this.state;
      if (!isReceiveProps) {
        dispatch(getAuthorityList());
        dispatch(getGroupList());
      }
      if (managementAuthorityList.length !== 0 && userDetail.userType === USER_TYPE.ADMIN) {
        userDetail.managementAuthoritySecernId =
          managementAuthorityList[0].managementAuthoritySecernId;
      }
      let selectedGroupList = [{ groupSecernId: '' }];
      if (user.userGroupRelationListUserLoging && user.userGroupRelationListUserLoging.length !== 0) {
        const groupRelationList = [...user.userGroupRelationListUserLoging];
        selectedGroupList = $.extend(true, [], user.userGroupRelationListUserLoging);
      }
      this.setState({
        mode,
        managementAuthorityList,
        groupList,
        userDetail,
        selectedGroupList,
      });
    }
    if (isReceiveProps && authedUser) {
      const serviceType = authedUser.serviceType;
      const { userDetail } = this.state;
      if (serviceType === SERVICE_TYPE.CONTENT_DISTRIBUTION) {
        userDetail.userType = USER_TYPE.ADMIN;
      }
      this.setState({ serviceType, userDetail });
    }

    if (service && isReceiveProps) {
      const { serviceInfo } = service;
      const { serviceList } = serviceInfo;
      if (serviceList && serviceList.length > 0) {
        const serviceDetail = $.grep(serviceList, e => e.serviceCd === authedUser.serviceCd);
        if (serviceDetail.length > 0) {
          this.setState({
            passwordStrength: serviceDetail[0].passwordStrength || PASS_STRENGTH_TYPE.STRONG,
          });
        }
      }
    }
    this.creatUserAttribute(mode, userAttributes);
  }

  getServiceForUser() {
    const { authedUser } = this.props;
    const { userInfo, institutionId } = authedUser;

    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      institutionId,
      searchInfo: {
        serviceCdList: [authedUser.serviceCd],
      },
    };
    this.props.dispatch(serviceSearchWithoutGetEnterprise(param));
  }

  /**
   * Create user attribute
   */
  creatUserAttribute(mode, attribute) {
    const userAttributeList = [];
    for (let i = 1; i <= 20; i++) {
      userAttributeList.push(i);
    }
    const userAttributes = userAttributeList.reduce(
      (acc, cur) => {
        const userAttribute =
          mode === MODE.EDIT_MODE && attribute.byKeyNum[cur]
            ? attribute.byKeyNum[cur].userAttribute
            : '';
        acc.byKeyNum[cur] = { userAttributeKeyNum: cur, userAttribute };
        acc.allKeyNums.push(cur);
        return acc;
      },
      {
        byKeyNum: {},
        allKeyNums: [],
      },
    );
    this.setState({ userAttributes });
  }

  handleFormChange(event) {
    const { name, value } = event.target;
    let { userDetail, childUserList } = this.state;
    const { managementAuthorityList } = this.state;
    if (name === 'userType') {
      if (parseInt(value, 10) !== USER_TYPE.ADMIN) {
        userDetail.managementAuthoritySecernId = '';
      } else if (managementAuthorityList.length > 0) {
        userDetail.managementAuthoritySecernId =
          managementAuthorityList[0].managementAuthoritySecernId;
      }
      if (parseInt(value, 10) === USER_TYPE.ADMIN && this.props.user.managementAuthoritySecernId) {
        userDetail.managementAuthoritySecernId = this.props.user.managementAuthoritySecernId;
      }
      if (parseInt(value, 10) !== USER_TYPE.GUARDIAN) childUserList = [];
      userDetail = { ...this.state.userDetail, ...{ [name]: value } };
    } else if (name === 'passwordChangeFlag' || name === 'isUnlock') {
      userDetail = {
        ...this.state.userDetail,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
    } else if (name === 'dormantStateChangeFlag') {
      userDetail = {
        ...this.state.userDetail,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
      if (!event.target.checked) {
        userDetail.dormantStateChangeDate = '';
      }
    } else if (name === 'loginIdPasswordSendFlag') {
      userDetail = {
        ...this.state.userDetail,
        ...{ [name]: event.target.checked ? 1 : 0 },
      };
    } else {
      userDetail = { ...this.state.userDetail, ...{ [name]: value } };
    }
    this.setState({
      userDetail,
      childUserList,
    });
  }

  handleTimeChange(name, value) {
    const userDetail = { ...this.state.userDetail, ...{ [name]: value } };
    this.setState({
      userDetail,
    });
  }

  /**
   * Handle change for input attribute field
   *
   * @param {interger} index
   * @param {object} e
   */
  onHandleChangeAttribute(keyNum, e) {
    const { userAttributes } = this.state;
    userAttributes.byKeyNum[keyNum].userAttribute = e.target.value;
    this.setState({ userAttributes });
  }

  /**
   * Handle open or close attribute erea
   */
  openOrCloseAttributeArea() {
    this.setState({
      isClosed: !this.state.isClosed,
      buttonText: this.state.isClosed ? 'minute' : 'plus',
    });
  }

  /**
   * Open select user dialog
   */
  showUserRelation() {
    this.setState({
      showRelationMode: true,
    });
  }

  /**
   * Handle event when click on OK of  select user dialog
   */
  onUserRelationOk(childUserList) {
    this.setState({
      showRelationMode: false,
      childUserList,
    }, () => {
      this.props.dispatch(editChildUserList(childUserList));
    });
  }

  /**
   * Handle event when click on キャンセル of  select user dialog
   */
  onUserRelationCancel() {
    this.setState({
      showRelationMode: false,
    });
  }

  /**
   * Show select group dialog
   */
  showSelectGroupDlg(indexGroup) {
    this.setState({
      showSelectGroup: true,
      indexGroup,
    });
  }

  /**
   * Handle event when click on キャンセル of select group dialog
   */
  cancelSelectGroupDlg() {
    this.setState({ showSelectGroup: false });
  }

  /**
   * Handle event when click on OK of group dialog
   *
   * @param {*} group
   */
  okSelectGroupDlg(group) {
    this.updateGroupData(group);
    this.setState({ showSelectGroup: false });
  }

  /**
   * Show check dialog
   */
  showCheckDlg() {
    let isValid = true;
    isValid = Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
    if (isValid) {
      this.setState({ showCheck: true });
    }
  }

  /**
   * Handle event when click on キャンセル of check dialog
   *
   */
  cancelCheckDlg() {
    this.setState({ showCheck: false });
  }

  /**
   * Handle event when click on OK of check dialog
   *
   */
  okCheckDlg() {
    // call user api
    const { dispatch } = this.props;
    dispatch(registerUpdateUser(this.state, this.props));
    this.setState({ showCheck: false });
  }

  /**
   * Update group data when user select group from group dialog
   *
   * @param {object} data
   */
  updateGroupData(data) {
    const { selectedGroupList, indexGroup } = this.state;
    if (data && data.groupSecernId) {
      selectedGroupList[indexGroup].groupSecernId = data.groupSecernId;
    }
    this.setState({ selectedGroupList });
  }

  /**
   * Add group
   */
  addGroup() {
    const groupItem = { groupSecernId: '' };
    const selectedGroupList = this.state.selectedGroupList;
    selectedGroupList.push(groupItem);
    this.setState({ selectedGroupList });
  }

  /**
   * Delete group
   *
   * @param {integer} index
   */
  deleteGroup(index) {
    const selectedGroupList = this.state.selectedGroupList;
    if (index === 0 && selectedGroupList.length === 1) {
      selectedGroupList[0].groupSecernId = '';
    } else {
      selectedGroupList.splice(index, 1);
    }
    this.setState({ selectedGroupList });
  }

  /**
   * Delete child user
   *
   * @param {integer} index
   */
  deleteChildUser(index) {
    const childUserList = this.state.childUserList;
    childUserList.splice(index, 1);
    this.setState({ childUserList });
  }

  backPage() {
    this.props.history.goBack();
  }

  render() {
    const {
      userDetail,
      groupList,
      childUserList,
      mode,
      selectedGroupList,
      userAttributes,
      indexGroup,
      showSelectGroup,
      showRelationMode,
      showCheck,
      passwordStrength,
      serviceType,
    } = this.state;
    const { user, authedUser } = this.props;
    let managementAuthoritySecernId = null;
    if (this.props.user && this.props.user.managementAuthoritySecernId) {
      managementAuthoritySecernId = this.props.user.managementAuthoritySecernId;
    }
    const { recordNumUserGroupRelationUserLoging } = user;
    this.refsToValidate = [];
    const isUserHasGroup = recordNumUserGroupRelationUserLoging > 0 ? true : false;
    let allGroupList = groupList;
    if (this.props.user.allGroup && this.props.user.allGroup.length) {
      allGroupList = this.props.user.allGroup;
    }
    const { userGroupRelationListUserLoging } = user;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.USER_LIST}
          text="ユーザー管理に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={mode === MODE.NEW_MODE ? 'ユーザーの追加' : 'ユーザーの編集'}/>
        <p className="margin-top-10">
          {mode === MODE.NEW_MODE ? '登録する項目を指定してください' : '編集する項目を指定してください'}
        </p>
        <UserRegisterUpdate
          {...this.state}
          handleFormChange={this.handleFormChange}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          onHandleChangeAttribute={this.onHandleChangeAttribute}
          onChangeLockUser={this.onChangeLockUser}
          openOrCloseAttributeArea={this.openOrCloseAttributeArea}
          showSelectGroupDlg={this.showSelectGroupDlg}
          showUserRelation={this.showUserRelation}
          addGroup={this.addGroup}
          deleteGroup={this.deleteGroup}
          deleteChildUser={this.deleteChildUser}
          showCheckDlg={this.showCheckDlg.bind(this)}
          serviceType={serviceType}
          managementAuthoritySecernId={managementAuthoritySecernId}
          recordNumUserGroupRelationUserLoging={recordNumUserGroupRelationUserLoging}
          selectedGroupList={this.state.selectedGroupList}
          allGroupList={allGroupList}
          userGroupRelationListUserLoging={userGroupRelationListUserLoging}
          handleTimeChange={this.handleTimeChange}
          loginIdPasswordSendFlag={userDetail.loginIdPasswordSendFlag}
          mfaUsageFlag={authedUser.mfaUsageFlag} // Step10.0.0
        />
        {userDetail.userType == 1 &&
          showRelationMode && (
            <ChildUserContainer
              showModal={showRelationMode}
              childUserList={childUserList}
              onCancel={this.onUserRelationCancel}
              onOK={this.onUserRelationOk}
            />
          )}
        {showSelectGroup && <SelectGroupDlg
          showModal={showSelectGroup}
          selectedGroupList={selectedGroupList}
          selectedGroup={selectedGroupList[indexGroup]}
          groupList={groupList}
          onCancel={this.cancelSelectGroupDlg}
          onOK={this.okSelectGroupDlg}
        />
        }
        <UserCheckContainer {...this.state} onCancel={this.cancelCheckDlg} onOK={this.okCheckDlg} allGroupList={allGroupList} />
        <Form.Group className="margin-top-20 text-center">
          <Col sm={12} className="text-center">
            {mode === MODE.EDIT_MODE && (
              <Button variant="default" className="margin-10 btn btn-default btn-96" onClick={this.backPage.bind(this)}>
                キャンセル
              </Button>
            )}
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.showCheckDlg.bind(this)}
            >
              OK
            </Button>
          </Col>
        </Form.Group>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ user: state.user },
  ...{ authedUser: state.authed.authedUser },
  ...{ service: state.service },
});

export default connect(mapStateToProps)(UserRegisterUpdateContainer);
